import React, { useEffect } from 'react';
import { Button, Typography, Space, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import Prism from 'prismjs';
import 'prism-themes/themes/prism-ghcolors.css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';

const { Text } = Typography;

const CodeBlockComponent = ({ code, language = 'javascript' }) => {
  useEffect(() => {
    Prism.highlightAll();
  }, [code, language]);

  const fallbackCopyToClipboard = (text) => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (successful) {
        message.success('¡Copiado!');
      } else {
        throw new Error('execCommand falló');
      }
    } catch (err) {
      console.error('Error al copiar (fallback):', err);
      message.error('No se pudo copiar');
    }
  };

  const handleCopy = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(code);
        message.success('¡Copiado!');
      } catch (err) {
        console.error('Error al copiar el código:', err);
        message.error('No se pudo copiar');
        fallbackCopyToClipboard(code); // intenta con fallback si falla
      }
    } else {
      fallbackCopyToClipboard(code);
    }
  };

  return (
    <div className="code-block-wrapper">
      <div className="code-block-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space>
          <Text type="secondary">{language.toUpperCase()}</Text>
        </Space>
        <Button
          icon={<CopyOutlined />}
          size="small"
          onClick={handleCopy}
        >
          Copiar
        </Button>
      </div>
      <pre className={`language-${language}`}>
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  );
};

export default CodeBlockComponent;
